import { use } from 'react';

import { UserContextObj } from '../context';
import { type UserContext } from '../types';

/**
 * A hook that can be used to access the authenticated user context, {@link UserContext}.
 */
export const useUser = (): UserContext => {
  const context = use(UserContextObj);
  if (!context) {
    throw new Error("The 'useUser' hook can only be used inside of the 'UserProvider'!");
  }
  return context;
};
